import { post } from './axios.js'

/**
 * FCST Summary List - /dashboard/getFCSTSummaryList
 * @param {object} params
 * @param {string} parmas.fs_year - 년도
 * @param {string} parmas.employee_id - 전체 = ''
 * @returns {object}
 */

export async function getFCSTSummaryList(params) {
  try {
    const result = await post('/dashboard/getFCSTSummaryList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * Total REV. GM List (영업대표) - /dashboard/getTotalItemsRevGMSalesUserList
 * @param {object} params
 * @returns {object}
 */
export async function getTotalItemsRevGMSalesUserList(params) {
  try {
    const result = await post('/dashboard/getTotalItemsRevGMSalesUserList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * Total REV. GM List (Stage) - /dashboard/getTotalRevGMList
 * @param {object} params
 * @returns {object}
 */
export async function getTotalRevGMList(params) {
  try {
    const result = await post('/dashboard/getTotalRevGMList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * Total REV. GM List (상품) - /dashboard/getTotalItemsRevGMList
 * @param {object} params
 * @returns {object}
 */
export async function getTotalItemsRevGMList(params) {
  try {
    const result = await post('/dashboard/getTotalItemsRevGMList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * 범례그룹 정의 - /dashboard/getSalesGroupList
 * @param {object} params
 * @param {string} parmas.fs_year - 년도
 * @returns {object}
 */
export async function getSalesGroupList() {
  try {
    const result = await post('/dashboard/getSalesGroupList', {})
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * Rev. & GM FCST - /dashboard/getFCSTItemsList
 * @param {object} params
 * @param {string} parmas.fs_year - 년도
 * @param {string} parmas.employee_id - 전체 = null
 * @returns {object}
 */
export async function getFCSTItemsList(params) {
  try {
    const result = await post('/dashboard/getFCSTItemsList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * PipeLine Management - /dashboard/getPipelineManagementList
 * @param {object} params
 * @param {string} parmas.fs_year - 년도
 * @param {string} parmas.employee_id - 전체 = null
 * @returns {object}
 */
export async function getPipelineManagementList(params) {
  try {
    const result = await post('/dashboard/getPipelineManagementList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * PipeLine Status - /dashboard/getPipelineStatusList
 * @param {object} params
 * @param {string} parmas.fs_year - 년도
 * @param {string} parmas.employee_id - 전체 = null
 * @returns {object}
 */
export async function getPipelineStatusList(params) {
  try {
    const result = await post('/dashboard/getPipelineStatusList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * PipeLine Status (상품) - /dashboard/getPipelineStatusGoodsList
 * @param {object} params
 * @param {string} parmas.fs_year - 년도
 * @param {string} parmas.employee_id - 전체 = null
 * @returns {object}
 */
export async function getPipelineStatusGoodsList(params) {
  try {
    const result = await post('/dashboard/getPipelineStatusGoodsList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * PipeLine Hygiene - /dashboard/getPipeLineHygieneList
 * @param {object} params
 * @returns {object}
 */
export async function getPipeLineHygieneList(params) {
  try {
    const result = await post('/dashboard/getPipeLineHygieneList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * Final Balance FCST - /dashboard/getPipeLineBalanceList
 * @param {object} params
 * @returns {object}
 */
export async function getPipeLineBalanceList(params) {
  try {
    const result = await post('/dashboard/getPipeLineBalanceList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * 메인 > 영업기회 쿼터리스트 - /dashboard/getQuerterList
 * @param {object} params
 * @param {string} params.employee_id 관리자 권한이면 null 그 외 자신 employee_id
 * @returns {object}
 */
export async function getQuerterList(params={}) {
  try {
    const result = await post('/dashboard/getQuerterList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}


/**
 * 메인 > 영업기회 won top3 - /dashboard/getQutaWonOpptyTop3List
 * @param {object} params
 * @param {string} params.employee_id 관리자 권한이면 null 그 외 자신 employee_id
 * @returns {object}
 */
export async function getQutaWonOpptyTop3List(params={}) {
  try {
    const result = await post('/dashboard/getQutaWonOpptyTop3List', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * 메인 > 영업기회 COMMIT top3 - /dashboard/getQutaCommitOpptyTop3List
 * @param {object} params
 * @param {string} params.employee_id 관리자 권한이면 null 그 외 자신 employee_id
 * @returns {object}
 */
export async function getQutaCommitOpptyTop3List(params={}) {
  try {
    const result = await post('/dashboard/getQutaCommitOpptyTop3List', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * 대쉬보드 : Monthly Rev&GM FCST 1  (End-User) - /dashboard/getCategoriesOneValues
 * @param {object} params
 * @returns {object}
 */
export async function getCategoriesOneValues(params) {
  try {
    const result = await post('/dashboard/getCategoriesOneValues', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * 대쉬보드 : Monthly Rev&GM FCST 2  (상품) - /dashboard/getCategoriesTwoValues
 * @param {object} params
 * @returns {object}
 */
export async function getCategoriesTwoValues(params) {
  try {
    const result = await post('/dashboard/getCategoriesTwoValues', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * 대쉬보드 : Monthly Rev&GM FCST 3  (매입처) - /dashboard/getCategoriesThreeValues
 * @param {object} params
 * @returns {object}
 */
export async function getCategoriesThreeValues(params) {
  try {
    const result = await post('/dashboard/getCategoriesThreeValues', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}

/**
 * weeklyRevenueGrossMarginReport 대시보드 weekly history - /dashboard/weeklyRevenueGrossMarginReport
 * @param {object} params
 * @property {string} params.fs_year
 * @returns
 */
export async function weeklyRevenueGrossMarginReport(params = {}) {
  try {
    const result = await post('/dashboard/weeklyRevenueGrossMarginReport', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 대시보드 레이아웃 가져오기 - /dashboard/dasboardLayoutList
 * @returns
 */
export async function dasboardLayoutList(params = { dl_type: "M01" }) {
  try {
    const result = await post('/dashboard/dasboardLayoutList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 대시보드 레이아웃 저장 - /dashboard/dasboardLayoutEdit
 * @param {object} params
 * @property {string} params.dl_type - 'M01'
 * @property {Array} params.widgetsVOListVo
 * @property {object} params.widgetsVOListVo[number]
 * @property {string} params.widgetsVOListVo[number].dl_seq
 * @property {string} params.widgetsVOListVo[number].widgets_cd
 * @property {string} params.widgetsVOListVo[number].widgets_nm
 * @property {number} params.widgetsVOListVo[number].widgets_top
 * @property {number} params.widgetsVOListVo[number].widgets_left
 * @property {number} params.widgetsVOListVo[number].widgets_width
 * @property {number} params.widgetsVOListVo[number].widgets_height
 * @returns
 */
export async function dasboardLayoutEdit(params = []) {
  try {
    const result = await post('/dashboard/dasboardLayoutEdit', { dl_type: 'M01', widgetsVOListVo: params })
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}
/**
 * 회계년도 리스트 - /dashboard/getSalesGroupList
 * @param {object} params
 * @param {string} parmas.fs_year - 년도
 * @returns {object}
 */
export async function getFcstYearList(params = {}) {
  try {
    const result = await post('/dashboard/getFcstYearList', params)
    return result.data
  } catch (e) {
    throw new Error(e)
  }
}